import { useHistory } from "react-router-dom";
import { OverlaySpinner } from "../../../components/OverlaySpinner";
import { SetupFlow } from "../../../components/SetupFlow/SetupFlow";
import { useWSMutation } from "../../../query/helpers";
import { useUserId } from "../../../query/hooks/helpers";
import { QUERY_USERS_ACTIVITIES } from "../../../query/users/keys";
import { useMemberProfile } from "../../../query/users/queries";
import { WSQueries } from "../../../query/WSQuery";
import { usersService } from "../../../services/users";
import { useSetWSStore } from "../../../store";
import { useWSAnalytics } from "../../../utils/WSAnalytics";
import { BusinessDetailsForm } from "./BusinessDetailsForm";
import { Complete1099Onboarding } from "./Complete1099Onboarding";
import { ConfirmElectronic1099Consent } from "./ConfirmElectronic1099Consent";
import { PersonalDetailsForm } from "./PersonalDetailsForm";
import { VerifyTIN } from "./VerifyTIN";

type Onboarding1099Props = {
  basePath: string;
  onBack: () => Promise<void> | void;
  onFinish: () => Promise<void> | void;
};
export const Onboarding1099: React.FC<Onboarding1099Props> = ({
  basePath,
  onBack,
  onFinish
}) => {
  const history = useHistory();
  const userId = useUserId();
  const memberQuery = useMemberProfile(userId);
  const { track } = useWSAnalytics();

  const [finishOnboarding, finishOnboardingMeta] = useWSMutation(
    async () => {
      await usersService.activity.update(userId, {
        flows: {
          onboarding1099: {
            version: 1,
            currentStep: 4,
            totalSteps: 4,
            complete: true
          }
        }
      });

      track.other("Product activation");

      await onFinish();
    },
    {
      dependencies: [QUERY_USERS_ACTIVITIES]
    }
  );

  return (
    <WSQueries queries={{ memberQuery }}>
      {({ memberQuery: { data: member } }) => {
        return (
          <>
            {finishOnboardingMeta.isLoading && <OverlaySpinner />}

            <SetupFlow
              basePath={basePath}
              routes={[
                {
                  path: "/business",
                  component: BusinessDetailsForm,
                  onBack: onBack,
                  onNext: () => {
                    history.push(basePath + "/personal");
                  }
                },
                {
                  path: "/personal",
                  component: PersonalDetailsForm,
                  onBack: () => {
                    history.push(basePath + "/business");
                  },
                  onNext: context => {
                    history.push(basePath + "/consent");
                  }
                },
                {
                  path: "/consent",
                  component: VerifyTIN,
                  onBack: () => {
                    history.push(basePath + "/personal");
                  },
                  onNext: () => {
                    history.push(basePath + "/electronic-1099-consent");
                  }
                },
                {
                  path: "/electronic-1099-consent",
                  component: ConfirmElectronic1099Consent,
                  onBack: () => {
                    history.push(basePath + "/consent");
                  },
                  onNext: () => {
                    history.push(basePath + "/complete");
                  }
                },
                {
                  path: "/complete",
                  component: Complete1099Onboarding,
                  onBack: () => {
                    history.push(basePath + "/electronic-1099-consent");
                  },
                  onNext: () => {
                    finishOnboarding();
                  }
                }
              ]}
            />
          </>
        );
      }}
    </WSQueries>
  );
};
